import React from "react";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import { ProductUnitComponentWrapper } from "./ProductUnitComponentWrapper";

export default function ProductList() {
    const [searchParams] = useSearchParams();
    const location = useLocation();

    const tableParam = searchParams.get('table_id');

    // 1️⃣ حالت قدیمی: /product?id=5574
    const idFromQuery = searchParams.get("id");

    // 2️⃣ حالت جدید: /product/5574/iphone-14
    const pathParts = location.pathname.split("/");
    const idFromPath = pathParts[2]; // /product/{id}/{slug}

    // ✅ اولویت با Path است، بعد Query
    const id = idFromPath || idFromQuery;

    if (!id) return <p>محصولی انتخاب نشده است.</p>;


    return (
        <ProductUnitComponentWrapper
            route={"product_detail"}
            product_id={id}
            table_id={tableParam}  // <-- پاس دادن به کامپوننت
        />
    );
}
